export default "__VITE_PUBLIC_ASSET__38784c6b__"